import { type WinType } from '@kfiroo/backgammon-core'

type Outcome = 'winner' | 'loser' | 'spectator'

const LABELS: Record<Outcome, Record<WinType, string>> = {
  winner: {
    normal: 'You Won',
    gammon: 'Mars Winner',
    backgammon: 'Turkish Mars Winner',
  },
  loser: {
    normal: 'You Lost',
    gammon: 'Mars Loser',
    backgammon: 'Turkish Mars Loser',
  },
  spectator: {
    normal: 'Won',
    gammon: 'Mars Winner',
    backgammon: 'Turkish Mars Winner',
  },
}

export function winLabel(outcome: Outcome, winType: WinType): string {
  return LABELS[outcome][winType]
}
